import AWS from 'aws-sdk'
import request from 'superagent'
import { uploadPhotosToS3 } from '../actions';
const host = window.location.hostname
const local = (host.indexOf("local") > -1);
const staging = host.indexOf('staging') > -1;
const develop = (host.indexOf('develop.') > -1)
const ROOT_URL = (local || develop)
  ? 'https://myphoto-api-develop.appspot.com'
  : (staging)
    ? 'https://myphoto-api-staging.appspot.com'
    : 'https://mp-cloud-api.appspot.com'
const getPreSignedUrl = (key, token, bucket) => (
  request.post(`${ROOT_URL}/auth/s3policy`)
    .send({
      fileName: key,
      bucket: bucket
    })
    .set({ Authorization: token })
    .then(response => {
      return response
    })
)

const uploadToS3 = ({ bucket, key, awsAccessKeyId, policy, signature, file, productId }) => {
  const baseUrl = `https://${bucket}.s3.amazonaws.com/`
  const formData = new FormData()
  formData.append('key', key)
  formData.append('AWSAccessKeyId', awsAccessKeyId)
  formData.append('policy', policy)
  formData.append('signature', signature)
  formData.append('acl', 'public-read')
  formData.append('Content-Type', file.type)
  formData.append('file', file)
  formData.append('success_action_status', '201')
  return request.post(baseUrl)
    .send(formData)
    .then((res) => {
      if (res.statusCode > 200 && res.statusCode < 300) {
        return {
          fileName: `https://s3.amazonaws.com/${bucket}/${key}`,
          sucess: true,
          id: productId
        }
      } else {
        return 'Error in upload'
      }
    })
    .catch((err) => {
      console.log('ERROR caught in uploadToS3', err)
      return {
        fileName: `https://s3.amazonaws.com/${bucket}/${key}`,
        sucess: false,
        id: productId
      }
    })
}

export function uploadImage (file, bucket, token, productId) {
  const getKey = file => encodeURI(`${Date.now()}-${file.name}`.replace(/([^a-z0-9.]+)/gi, ''))
  const key = getKey(file[0])
  return getPreSignedUrl(key, token, bucket)
    .then(response =>
      uploadToS3({
        bucket: response.body.bucket,
        key,
        awsAccessKeyId: response.body.awsKey,
        policy: response.body.policy,
        signature: response.body.signature,
        file: file[0],
        productId
      }))
      .catch((err)=>{
        console.log("ERROR uploading the image to S3", err)
      })
}



// WEBPACK FOOTER //
// ./src/lib/upload.js